/* eslint-disable react/jsx-props-no-spreading */
import React, { CSSProperties } from 'react';
import { string } from 'prop-types';

export declare type SvgIconProps = {
  icon: string,
  className?: string,
  style?: CSSProperties,
  'aria-label'?: string,
  role?: string,
  'aria-hidden'?: boolean,
  ref?: React.ForwardedRef<HTMLElement>
};

// Equivalent of svg_icon defined in bendigo_helper without icon class
const BaseSvgIcon = React.forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
  const { icon, ...outerProps } = props;

  return (
    <svg {...outerProps} ref={ref}>
      <use xlinkHref={`#icon-${icon}`} />
    </svg>
  );
});

BaseSvgIcon.propTypes = {
  icon: string.isRequired
};

export default BaseSvgIcon;
